import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';
import { Avatar, Button, Dropdown } from 'antd';
import { useNavigate } from 'react-router-dom';

import { useLogout } from '@/features/auth';
import { useAuth } from '@/providers/auth-provider';

import { Breadcrumbs } from '../breadcrumbs';
import { useSidebarStore } from '../sidebar';

import styles from './topbar.module.scss';

export function Topbar() {
  const { collapsed, toggle } = useSidebarStore();
  const { user } = useAuth();
  const navigate = useNavigate();
  const logout = useLogout();

  const initials =
    user?.name
      .trim()
      .split(/\s+/)
      .filter(Boolean)
      .map((n) => n[0]!.toUpperCase())
      .slice(0, 2)
      .join('') || '?';

  return (
    <header className={styles.bar}>
      <div className={styles.left}>
        <Button
          type="text"
          icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
          onClick={toggle}
          aria-label="Toggle sidebar"
        />
        <Breadcrumbs />
      </div>
      <div className={styles.right}>
        <Dropdown
          menu={{
            items: [
              {
                key: 'logout',
                label: 'Log out',
                onClick: async () => {
                  await logout.mutateAsync();
                  navigate('/login');
                },
              },
            ],
          }}
          trigger={['click']}
        >
          <Avatar style={{ cursor: 'pointer' }}>{initials}</Avatar>
        </Dropdown>
      </div>
    </header>
  );
}
